import { Link, useLocation } from 'react-router-dom';

import { ErrorBoundary } from '@/components/layout/ErrorBoundary';
import { NotificationMenu } from '@/components/layout/NotificationMenu';
import { ProfileMenu } from '@/components/layout/ProfileMenu';
import { HomeRoute } from '@/configs/routes';

export function Header() {
  const location = useLocation();

  return (
    <ErrorBoundary locationKey={location.key} component="Header">
      <div className="bg-[#1E2F52] border-b border-[#274483] flex items-center justify-between p-2 pr-4 h-[52px]">
        <Link to={{ pathname: HomeRoute, search: location.search }}>
          <div className="flex items-center gap-2 mr-6">
            <div className="flex flex-col px-[3px]">
              <h1 className="text-base font-semibold text-white whitespace-nowrap leading-tight">keystone.ai</h1>
              <p className="text-xs text-white whitespace-nowrap leading-tight">Deep Enterprise Platform&#8482;</p>
            </div>
          </div>
        </Link>

        <div className="hidden md:flex items-center space-x-4">
          <NotificationMenu />
          <ProfileMenu />
        </div>
      </div>
    </ErrorBoundary>
  );
}
